export default __webpack_public_path__ + "1d9f06d6b7142e5bcee2392392465033.png";